import { render, staticRenderFns } from "./JournalReceived.vue?vue&type=template&id=f7d36bea&scoped=true&"
import script from "./JournalReceived.vue?vue&type=script&lang=js&"
export * from "./JournalReceived.vue?vue&type=script&lang=js&"
import style0 from "./JournalReceived.vue?vue&type=style&index=0&id=f7d36bea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d36bea",
  null
  
)

export default component.exports